import { Location } from '@angular/common';
import { EventEmitter, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { paths, productosPath } from '../helpers/constants';
import { findInObjectByField } from '../helpers/helper';
import { IMenu, IMenuItem, IRoute, ITabIndexes } from './../Entities/entities';

@Injectable({
  providedIn: 'root',
})
export class EventsService {
  private menu: IMenu = { title: '', route: { path: '' }, items: [] };
  menuChange$: EventEmitter<IMenu>;
  alternativasTrasladoChange$: EventEmitter<string[]>;
  routeChange$: EventEmitter<IRoute[]>;
  routeLifeMax$: EventEmitter<boolean>;
  routerTabNavigation$: EventEmitter<ITabIndexes>;
  recargarBenef$: EventEmitter<boolean>;
  visibilityPagarProductos$: EventEmitter<boolean>;
  visibilityInformeRentabilidad$: EventEmitter<boolean>;
  routerSubscription: Subscription;
  private currentRoute: IRoute = { path: '' };
  private routeTree: IRoute[] = [];
  private AlternativasTrasladosSelected: string[] = [];
  private lifeMax;

  constructor(location: Location, router: Router) {
    this.menuChange$ = new EventEmitter();
    this.routeChange$ = new EventEmitter();
    this.routeLifeMax$ = new EventEmitter();
    this.routerTabNavigation$ = new EventEmitter<ITabIndexes>();
    this.alternativasTrasladoChange$ = new EventEmitter();
    this.visibilityPagarProductos$ = new EventEmitter();
    this.visibilityInformeRentabilidad$ = new EventEmitter();
    this.recargarBenef$ = new EventEmitter<boolean>();
    this.routerSubscription = router.events.subscribe(val => {
      if (location.path() !== this.currentRoute.path) {
        this.currentRoute.path = location.path();

        const pathsArray = this.currentRoute.path.split('/');
        pathsArray.splice(0, 1);
        // const currentRoot = this.getMenu();
        this.routeTree.length = 0;

        switch (pathsArray[0]) {
          case productosPath.path:
            pathsArray.forEach(p => {
              const pt = findInObjectByField(productosPath, p);
              if (pt) {
                this.addRouteToRouterTree(pt);
              } /*  else {
                const i = p.indexOf('nombre');
                if (i > 0) {
                  const label = decodeURI(p).substring(i + 7);
                  this.addRouteToRouterTree({ path: '', label: label });
                }
              } */
            });
            break;

          default:
            break;
        }
      }
    });
  }

  addRouteToRouterTree(route: IRoute, popNItems: number = 0) {
    for (let index = 0; index < popNItems; index++) {
      this.routeTree.pop();
    }
    this.routeTree.push(route);
    this.routeChange$.emit(this.routeTree);
  }

  getCurrentRoute() {
    return this.currentRoute;
  }

  setMenu(items: IMenuItem[]) {
    const rootPath = this.getCurrentRoute().path.split('/')[1];
    switch (rootPath) {
      case 'productos':
        this.menu.title = 'MIS PRODUCTOS';
        this.menu.route = productosPath;
        break;
      case 'firmaElectronica':
        this.menu.title = '';
        this.menu.route = paths.firmaElectronica;
        break;
      default:
        break;
    }
    // const itSegIndividual = items.find(it => it.route.path === 'individual');
    // this.menu.individual = itSegIndividual !== undefined;
    this.menu.items = items;
    this.menuChange$.emit(this.menu);
  }

  getMenu() {
    return this.menu;
  }

  sendLifeMax(message: boolean) {
    this.lifeMax = message;
    this.routeLifeMax$.emit(message);
  }

  getLifeMax(): boolean {
    return this.lifeMax;
  }

  setVisibilityPagarProducto(value: boolean) {
    this.visibilityPagarProductos$.emit(value);
  }

  setVisibilityInforme(value: boolean) {
    this.visibilityInformeRentabilidad$.emit(value);
  }

  setAlternativasTrasladosSelected(value: string[]) {
    this.AlternativasTrasladosSelected = value;
  }

  getAlternativasTrasladosSelected() {
    return this.AlternativasTrasladosSelected;
  }

  setTabIndex(value: ITabIndexes) {
    this.routerTabNavigation$.emit(value);
  }

  recargarInfoBeneficiario(value: boolean) {
    this.recargarBenef$.emit(value);
  }
}
